"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toggleActivityFitter = () => {
    try {
        const filterToggle = document.querySelector('#filter-toggle');
        const filterLampsElement = document.querySelector('#filter-lamps-element');
        const filterCloseElement = document.querySelector('.filter-lamps__close-boby');
        const body = document.body;
        filterToggle?.addEventListener('click', () => {
            filterLampsElement?.classList.add('active-filter');
        });
        filterCloseElement?.addEventListener('click', () => {
            filterLampsElement?.classList.remove('active-filter');
        });
    }
    catch (error) {
        console.log('Error in function toggleActivityFitter >>> ', error);
    }
};
exports.default = toggleActivityFitter;
